<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="timePeriodForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" formControlName="monday" id="monday">
                <label class="form-check-label" for="monday">Monday</label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" formControlName="tuesday" id="tuesday">
                <label class="form-check-label" for="tuesday">Tuesday</label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" formControlName="wednesday" id="wednesday">
                <label class="form-check-label" for="wednesday">Wednesday</label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" formControlName="thursday" id="thursday">
                <label class="form-check-label" for="thursday">Thursday</label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" formControlName="friday" id="friday">
                <label class="form-check-label" for="friday">Friday</label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" formControlName="saturday" id="saturday">
                <label class="form-check-label" for="saturday">Saturday</label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" formControlName="sunday" id="sunday">
                <label class="form-check-label" for="sunday">Sunday</label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="name">Name</label>
              <input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
            </div>
            <div class="col-md-4 mb-3">
              <label for="startTime">Start Time</label>
              <input type="text" class="form-control" formControlName="startTime" id="startTime" placeholder="Start Time">
            </div>
            <div class="col-md-4 mb-3">
              <label for="endTime">End Time</label>
              <input type="text" class="form-control" formControlName="endTime" id="endTime" placeholder="End Time">
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(timePeriodForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
